// 日本語正規化ユーティリティ

/**
 * 日本語文字列を正規化して比較可能な形式に変換
 */
export function normalizeJapanese(text: string): string {
  return text
    // 全角スペースを半角に
    .replace(/\u3000/g, ' ')
    // 連続するスペースを1つに
    .replace(/\s+/g, ' ')
    // 前後のスペースを削除
    .trim()
    // カタカナをひらがなに変換
    .replace(/[\u30A1-\u30F6]/g, (match) => {
      const code = match.charCodeAt(0) - 0x60;
      return String.fromCharCode(code);
    })
    // 全角英数を半角に
    .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    })
    // 小文字に統一
    .toLowerCase()
    // 長音記号の統一（ー、〜、～ を - に）
    .replace(/[ー〜～]/g, '-')
    // 句読点を除去
    .replace(/[、。，．]/g, '');
}

/**
 * 答えが正解リストに含まれるかチェック
 */
export function checkAnswer(
  input: string,
  canonical: string,
  synonyms: string[] = []
): boolean {
  const normalizedInput = normalizeJapanese(input);
  const normalizedCanonical = normalizeJapanese(canonical);
  
  if (normalizedInput === normalizedCanonical) {
    return true;
  }
  
  return synonyms.some(synonym => 
    normalizeJapanese(synonym) === normalizedInput
  );
}

/**
 * 絵文字を含む文字列を安全な表示用に変換
 */
export function sanitizeDisplayName(name: string): string {
  // 絵文字を検出して置換
  const emojiRegex = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/gu;
  
  return name.replace(emojiRegex, '◆');
}

/**
 * CSVデータをパース
 */
export function parseAnswersCsv(csvContent: string): Array<{
  id: string;
  canonical: string;
  synonyms: string[];
}> {
  const lines = csvContent.split('\n').filter(line => line.trim());
  const answers = [];
  
  // ヘッダー行をスキップ
  for (let i = 1; i < lines.length; i++) {
    const [id, canonical, ...synonyms] = lines[i].split(',').map(s => s.trim());
    if (id && canonical) {
      answers.push({
        id,
        canonical,
        synonyms: synonyms.filter(s => s)
      });
    }
  }
  
  return answers;
}